
import {
  LMap,
  LTileLayer,
  LControlScale,
  LCircle,
  LControl,
  LPolyline,
  LPolygon,
  LPopup,
  LMarker,
  LTooltip,
  LGeoJson,
  LIcon,
} from '@vue-leaflet/vue-leaflet'
import { nextTick, ref, PropType, watch, onMounted, onUnmounted, computed, defineComponent } from 'vue'
import { useStore } from 'vuex'
import L from 'leaflet'
/* globalThis.L = L */
import { LMarkerClusterGroup } from 'vue-leaflet-markercluster'
import 'leaflet/dist/leaflet.css'
import 'vue-leaflet-markercluster/dist/style.css'
import 'leaflet-editable'
import 'leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';
import { PluginOptions, SimpleMapScreenshoter } from 'leaflet-simple-map-screenshoter'
import area from '@turf/area'
import { saveAs } from 'file-saver'

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/swiper-vue';
// Import Swiper styles
import 'swiper/swiper.css';
import 'swiper/modules/pagination.css';
import 'swiper/modules/navigation.css';
// Import required modules
import { Navigation } from 'swiper/modules';
import { Districts, Map } from '@/store/enums/StoreEnums';
import NewsDropDown from '@/components/dropdown/NewsDropDown.vue';
import { hideModal } from "@/core/helpers/dom";
import { baseUrl } from '@/utils/global';
import Dropdown1 from '@/components/dropdown/Dropdown1.vue';
import { useRoute } from 'vue-router'

interface Pipe {
  PAGE_ROW_NUMBER: number
  c_nguoi_cap_nhat_cuoi: string
  c_nguoi_tao: string
  c_ten_loai_ong: string
  c_ten_tuyen_ong: string
  c_thong_tin_ve_tuyen_ong: string
  d_ngay_cap_nhat_cuoi: string
  d_ngay_tao: string
  n_do_dai: number
  n_don_vi_do_dai: number
  n_kich_thuoc_ong: number
  n_ma_cong_ty: number
  n_ma_loai_ong: number
  n_ma_tuyen_ong: number
  n_tinh_trang: number
}

export default defineComponent({
  name: "mapVr360",
  components: {
    NewsDropDown,
    LMarkerClusterGroup,
    LMap,
    LTileLayer,
    LControlScale,
    LCircle,
    LControl,
    LPolyline,
    LPolygon,
    LPopup,
    LMarker,
    LTooltip,
    LGeoJson,
    Swiper,
    SwiperSlide,
    Dropdown1,
    LIcon
  },
  setup() {
    // Define Swiper options
    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        clickable: true,
      },
      navigation: true,
      modules: [Navigation],
    };

    const customIcon = new L.Icon({
      iconUrl: 'img/Map/location.gif',
      iconSize: [60, 60],
      iconAnchor: [30, 30], // bottom-center
    });

    const companyMap = ref<InstanceType<typeof LMap> | HTMLElement>()
    const mapOptions = ref({ editable: true, attributionControl: false, zoomControl: false, scrollWheelZoom: true })
    const pluginOptions: PluginOptions = {
      cropImageByInnerWH: true,
      hidden: true,
      preventDownload: false,
      domtoimageOptions: {},
      position: 'topleft',
      screenName: 'screen',
      iconUrl: undefined,
      hideElementsWithSelectors: ['.leaflet-control-container'],
      mimeType: 'image/png',
      caption: null,
      captionFontSize: 15,
      captionFont: 'Arial',
      captionColor: 'black',
      captionBgColor: 'white',
      captionOffset: 5
    }

    const leafletSS = ref<SimpleMapScreenshoter>(new SimpleMapScreenshoter(pluginOptions))
    const store = ref(useStore())
    const zoom = ref<number>(13)
    const tileProviders = ref([
      {
        name: 'Open Street map',
        shortName: 'OSM',
        visible: false,
        url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
        img: "img/Map/OSMap.jpg"
      },
      {
        name: 'Ảnh vệ tinh',
        shortName: 'Sattelite',
        visible: false,
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        img: "img/Map/Satellite.jpg"
      },
      {
        name: 'Map 4D',
        shortName: '4D',
        visible: false,
        url: 'https://rtile.map4d.vn/all/2d/{z}/{x}/{y}.png',
        img: "img/Map/Map4D.jpg"
      }
    ])

    const language = ref([
      {
        shortName: "VN",
        fullName: "Việt Nam",
        img: "media/flags/vietnam.svg"
      },
      {
        shortName: "EN",
        fullName: "English",
        img: "media/flags/united-kingdom.svg"
      },
    ])
    const isEN = ref<boolean>(false)

    const selectedTile = ref(
      {
        name: 'Lớp bản đồ street',
        shortName: 'STREET',
        visible: false,
        url: 'http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}',
        img: "img/Map/Map4D.jpg"
      }
    )
    const markerRefs = ref<any[]>([]);
    const center = ref<L.LatLngExpression>([20.7044298, 106.7810154])
    const bounds: L.LatLngBoundsExpression = [
      [19, 100],
      [25, 110]
    ]
    const action = ref<number>(0)
    const drawnMarkers = ref<L.LatLngExpression[]>([])
    const circleColor = ref<string>('#000')
    const drawnLines = ref<L.LatLngExpression[]>([])
    const value = ref<number>(0)
    const displayResult = ref<number>(0)
    const unit = ref<number>(0)
    const loading = ref<boolean>(false)
    const highLighted = ref<Pipe>()
    const geoData = ref()
    const geoResult = ref({
      city: '',
      district: '',
      ward: '',
      lat: '',
      lon: ''
    })
    const searchString = ref<string>('')
    const searchDistrict = ref<number>(-1)
    const modalSearchDistrict = ref<number>(-1)
    const filtered = ref<any[]>()
    const districtList = ref<any[]>([])
    const highLightDistrict = ref<boolean>(true)
    const districtBorders = ref<any>()
    const filter = (val) => {
      filtered.value = locationList.value.filter(i => {
        if (val != null && val !== '') {
          const lowerVal = val.toLowerCase(); // Convert input value to lowercase
          if (isEN.value) {
            return (i.enName as string).toLowerCase().includes(lowerVal); // Compare lowercase values
          } else {
            return (i.name as string).toLowerCase().includes(lowerVal); // Compare lowercase values
          }
        }
        return false;
      });
      if (filtered?.value?.length as number > 7) {
        filtered.value = filtered?.value?.splice(0, 7);
      }
    }
    const expanded = ref<boolean>(true)

    const toolboxOpen = ref<boolean>(false)
    const layerControlOpen = ref<boolean>(false)

    const mapModalRef = ref<HTMLElement | null>(null)
    const pageNum = ref<number>(1)
    const pageSize = ref<number>(12)
    const totalFilteredLocation = ref<number>(0)

    // Computed property to filter clocks
    const filteredLocationList = computed(() => {
      const fullList = locationList.value
      if (modalSearchDistrict.value == -1) {
        totalFilteredLocation.value = fullList.length
        return fullList.filter((i, index) => (index >= (pageNum.value - 1) * pageSize.value) && (index < pageNum.value * pageSize.value))
      }
      else {
        const item = districtList.value[modalSearchDistrict.value]
        const districtLocationList = fullList.filter((i) => i.districtId == item.id)
        totalFilteredLocation.value = districtLocationList.length
        return districtLocationList.filter((i, index) => {
          return (index >= (pageNum.value - 1) * pageSize.value) && (index < (pageNum.value * pageSize.value))
        })
      }
    })
    // Watcher for action changes
    watch(action, (newValue) => {
      const mapElement = document.getElementById('companyMap');
      if (newValue === 3 && mapElement && !mapElement.classList.contains('pointer')) {
        mapElement.classList.add('pointer');
      } else {
        if (mapElement && mapElement.classList.contains('pointer')) {
          mapElement.classList.remove('pointer');
        }
      }
    });

    const locationList = ref<any[]>(
      [
        {
          "id": 1,
          "latitude": "20.722986",
          "longitude": "106.800794",
          "image": "img/placeholder/den_ba_de.png",
          "url": "https://dulichdoson.vn/blog/iem-du-lich-tam-linh-3/en-ba-e-33",
          "category": "",
          "name": "Đền Bà Đế",
          "address": "Ngọc Xuyên, Đồ Sơn, Hải Phòng"
        },
        {
          "id": 2,
          "latitude": "20.714198",
          "longitude": "106.770220",
          "image": "img/placeholder/thap_tuong_long.png",
          "url": "https://dulichdoson.vn/blog/iem-du-lich-tam-linh-3/thap-tuong-long-32",
          "category": "",
          "name": "Tháp Tường Long",
          "address": "Vạn Sơn, Đồ Sơn, Hải Phòng"
        },
        {
          "id": 3,
          "latitude": "20.703234",
          "longitude": "106.766078",
          "image": "img/placeholder/rung_ngap_man.jpg",
          "url": "https://dulichdoson.vn/blog/du-lich-sinh-thai-13/rung-ngap-man-sinh-thai-o-son-79",
          "category": "",
          "name": "Rừng ngập mặn sinh thái",
          "address": "Khu sinh thái Đồ Sơn, Hải Phòng"
        },
        {
          "id": 4,
          "latitude": "20.701646",
          "longitude": "106.785490",
          "image": "img/placeholder/doi_rong_do_son.png",
          "url": "https://dragonoceandoson.vn/view360/",
          "category": "",
          "name": "Đồi Rồng Đồ Sơn",
          "address": "Khu du lịch Quốc tế Đồi Rồng, Đồ Sơn, Hải Phòng"
        },
        {
          id: 5,
          latitude: "20.6973863",
          longitude: "106.7917442",
          image: "img/placeholder/do_son_tren_cao.jpg",
          url: "",
          category: "",
          name: "Quận Đồ Sơn từ trên cao",
          address: ""
        },
        {
          "id": 6,
          "latitude": "20.683771",
          "longitude": "106.800716",
          "image": "img/placeholder/ben_nghieng.png",
          "url": "https://dulichdoson.vn/blog/iem-du-lich-tam-linh-3/ben-nghieng-18",
          "category": "",
          "name": "Bến Nghiêng",
          "address": "Vạn Hương, Đồ Sơn, Hải Phòng"
        },
        {
          "id": 7,
          "latitude": "20.677345",
          "longitude": "106.802603",
          "image": "img/placeholder/ben_tau_khong_so.png",
          "url": "https://dulichdoson.vn/blog/iem-du-lich-tam-linh-3/ben-tau-khong-so-k15-17",
          "category": "",
          "name": "Bến tàu không số (K15)",
          "address": "Vạn Hương, Đồ Sơn, Hải Phòng"
        },
        {
          "id": 8,
          "latitude": "20.6670294",
          "longitude": "106.8148327",
          "image": "img/placeholder/dao_hon_dau.png",
          "url": "https://dulichdoson.vn/blog/du-lich-bien-10/bai-tam-hon-dau-resort-75",
          "category": "",
          "name": "Đảo Hòn Dấu",
          "address": "Đảo Hòn Dấu, Vạn Hương, Đồ Sơn, Hải Phòng"
        }
      ]
    )
    const modalTitle = ref<string>("")
    const modalType = ref<boolean>(false)
    const introductionVideo = ref<string>("")
    const introductionTitle = ref<string>("")
    const preped = ref<boolean>(false)
    const PluginPrep = async () => {
      // Assuming these are reactive references or props passed to the component

      if (!leafletSS.value || !companyMap.value) {
        // Handle error or return if leafletSS or companyMap is not set

        return;
      }
      leafletSS.value.addTo((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map);

      await nextTick();
      /* findAllConfig()
      findAllDistrict() */
      getCurrentWeather()
      /* findAllLocation()
      getIntroVideo() */
      preped.value = true

    };

    const handleChangePage = (val) => {
      pageNum.value = val
    }


    const locationFound = (e: L.LocationEvent) => {
      ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).flyTo(e.latlng)
    };

    const locationError = (e: L.ErrorEvent) => {
      console.error('Location error:', e);
    };

    const openPopup = (index) => {
      if (markerRefs.value[index]) {
        markerRefs.value[index].leafletObject.openPopup();
      }
    };

    const locateUser = () => {
      ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).locate({});
      ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).once("moveend", () => {
        ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).setZoom(14)
      })

    }

    const zoomIn = () => {
      if (zoom.value < 18) {
        zoom.value++
      }
    }

    const zoomOut = () => {
      if (zoom.value > 8) {
        zoom.value--
      }
    }

    const toggleToolBox = () => {
      toolboxOpen.value = !toolboxOpen.value
      if (toolboxOpen.value) {
        layerControlOpen.value = false
      }
    }

    const toggleLayerControl = () => {
      layerControlOpen.value = !layerControlOpen.value
      if (layerControlOpen.value) {
        toolboxOpen.value = false
      }
    }

    const handleTileChange = (val, index) => {
      tileProviders.value[index] = selectedTile.value
      selectedTile.value = val
    }

    const flyToOnClick = async (item, index) => {
      await ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).flyTo([item.latitude, item.longitude], 17);
      ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).once("moveend", () => {
        if (index || index == 0) {
          openPopup(index)
        }
      })
    }

    const handleMoveToCenter = () => {
      ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map)
        .flyTo(center.value, 14);
    }

    const handleScreenShot = async () => {

      loading.value = true;

      const overridedPluginOptions = {
        mimeType: 'image/jng'
      };

      try {
        const blob = await leafletSS.value?.takeScreen('blob', overridedPluginOptions);
        saveAs(new Blob([blob as Blob]), 'Screen.png');
        loading.value = false;
      } catch (e) {
        alert(e);
        loading.value = false;
      }
    };

    const delay = (time) => {
      return new Promise((resolve) => setTimeout(resolve, time))
    }

    const handleDrawLine = () => {
      handleClose()
      action.value = 2
    }

    const handleDrawPolygon = () => {
      handleClose()
      action.value = 1
    }

    const handleFindInfo = () => {
      handleClose()
      action.value = 3
    }

    const expandSwiper = () => {
      expanded.value = !expanded.value;
      delay(300).then(() => {
        ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).invalidateSize();
      })
    }

    const handleClose = () => {
      action.value = 0
      handleUnHighlight()
      drawnLines.value = [] as L.LatLngExpression[]
      drawnMarkers.value = [] as L.LatLngExpression[]
      geoData.value = undefined
      geoResult.value = {
        city: '',
        district: '',
        ward: '',
        lat: '',
        lon: ''
      }
      value.value = 0
      displayResult.value = 0
    }

    const handleDrawMarker = (val) => {
      if (action.value == 1 || action.value == 2) {
        drawnMarkers.value.push(val.latlng)
        if (drawnMarkers.value.length >= 2) {
          handleDraw()
        }
      }
      if (action.value == 3) {
        reverseGeoCoding(val.latlng)
      }
    }

    const handleUndo = () => {
      if (drawnMarkers.value.length > 0) {
        drawnMarkers.value.splice(drawnMarkers.value.length - 1, 1)
        if (drawnMarkers.value.length >= 2) {
          handleDraw()
        } else {
          value.value = 0
          displayResult.value = 0
        }
      }
    }

    const handleDraw = () => {
      drawnLines.value = JSON.parse(JSON.stringify(drawnMarkers.value))
      if (action.value == 2) {
        handleCalculateDistance(drawnMarkers)
      }
      if (action.value == 1) {
        handleCalculate()
      }
    }

    const handleCalculateDistance = (coord) => {
      value.value = 0
      let length = coord.value.length
      for (let i = 0; i < length - 1; i++) {
        let lat1 = coord.value[i].lat
        let lat2 = coord.value[i + 1].lat
        let lon1 = coord.value[i].lng
        let lon2 = coord.value[i + 1].lng
        const R = 6371e3 // metres
        const φ1 = (lat1 * Math.PI) / 180 // φ, λ in radians
        const φ2 = (lat2 * Math.PI) / 180
        const Δφ = ((lat2 - lat1) * Math.PI) / 180
        const Δλ = ((lon2 - lon1) * Math.PI) / 180

        const a =
          Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
          Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

        const d = R * c // in metres
        value.value += d
      }

      if (value.value > 1000) {
        displayResult.value = parseFloat((value.value / 1000).toFixed(3))
        unit.value = 1
      } else {
        displayResult.value = parseFloat(value.value.toFixed(3))
      }

    }

    //tính diện tích
    const handleCalculate = () => {
      var polygon = L.polygon(drawnMarkers.value)
      var calc = area(polygon.toGeoJSON())
      value.value = Math.abs(calc)
      unit.value = 0

      if (value.value > 1000000) {
        value.value /= 1000000

        unit.value = 1
      }
      displayResult.value = parseFloat(value.value.toFixed(3))
    }

    const handleUnHighlight = () => {
      highLighted.value = undefined
    }
    //geoCoding
    const reverseGeoCoding = (val) => {
      geoData.value = undefined
      let lat = val.lat
      let lng = val.lng
      if (lat == null || lng == null) return false
      let url = `https://api-bdc.net/data/reverse-geocode?latitude=${lat}&longitude=${lng}&localityLanguage=vi&key=bdc_62348b9a89334a0abdf97d5a85a637e6`
      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error(res.statusText)
          return res.json()
        })
        .then((data) => {
          delay(200).then(() => {
            geoData.value = data
            handleResult()
          })
        })
        .catch((err) => {
          console.error(err)
        })
    }
    const handleResult = () => {
      geoResult.value = {
        city: '',
        district: '',
        ward: '',
        lat: '',
        lon: ''
      }
      let temp = geoData.value.localityInfo.administrative
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].adminLevel == 4) {
          geoResult.value.city = temp[i].name
        } else if (temp[i].adminLevel == 6) {
          geoResult.value.district = temp[i].name
        } else if (temp[i].adminLevel == 8) {
          geoResult.value.ward = temp[i].name
        }
      }
      geoResult.value.lat = parseFloat(geoData.value.latitude).toFixed(7)
      geoResult.value.lon = parseFloat(geoData.value.longitude).toFixed(7)
    }

    //dynamicSize
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    watch(windowWidth, (newValue) => {
      if (newValue < 768) {
        expanded.value = false
      } else {
        expanded.value = true
      }
    });

    const findDistrictBorders = async (index) => {
      if (index == -1) {
        districtBorders.value = {
          type: "Polygon",
          coordinates: []
        }
        highLightDistrict.value = true;
      } else {
        const item = districtList.value[index]
        const cleanedString = item.boundingBox.replace(/\s+/g, '');
        const coordinates = JSON.parse(cleanedString);
        const geojsonFeature = {
          type: coordinates.length > 1 ? "MultiPolygon" : "Polygon",
          coordinates: coordinates
        };
        districtBorders.value = geojsonFeature
        highLightDistrict.value = true;
        ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map)
          .flyTo([item.latitude, item.longitude], ((windowWidth.value < 768) ? 12 : 13));
      }

    }

    const findAllDistrict = () => {
      store.value.dispatch(Districts.findAll, {}).then(res => {
        if (res.code == 200)
          districtList.value = res.data
      })
    }
    const route = useRoute()
    const findAllLocation = () => {
      const locationId = route.query.id
      store.value.dispatch(Map.findAllLocation, {}).then(res => {
        if (res) {
          locationList.value = res.map(value => {
            return {
              id: value.id,
              latitude: value.acf.kinh_do.replace(',', '.'),
              longitude: value.acf.vi_do.replace(',', '.'),
              image: value.featured_image_url,
              url: value.acf.vr360 ? value.acf.vr360 : value.link,
              category: value.genre_dia_diem,
              name: value.title_raw,
              address: value.acf.dia_chi ? value.acf.dia_chi : ''
            }
          })

          if (locationId) {
            const locationIndex = locationList.value.findIndex(item => item.id === parseInt(locationId as string));
            if (locationIndex !== -1) {
              flyToOnClick(locationList.value[locationIndex], locationId);
            }
          }
        }
      })
    }

    /* const findAllConfig = () => {
      store.value.dispatch(Map.findConfigData, {}).then(res => {
        if (res.code == 200) {
          center.value = res.data.filter(i => i.configKey == "map_center_coordinate")[0]?.value?.split(",");
          zoom.value = Number(res.data.filter(i => i.configKey == "map_zoom_level")[0]?.value);
          ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).setView(center.value, zoom.value)
          const providers = res.data.filter(i => ["map_4d", "map_street", "map_satellite", "map_openstreetmap"].includes(i.configKey))
          selectedTile.value = {
            name: providers[0].configKey == "map_openstreetmap" ? 'Open Street map' : providers[0].configKey == "map_4d" ? "Map 4D" : providers[0].configKey == "map_street" ? "Map street" : "Satellite",
            shortName: providers[0].configKey == "map_openstreetmap" ? 'OSM' : providers[0].configKey == "map_4d" ? "4D" : providers[0].configKey == "map_street" ? "Street" : "Satellite",
            visible: false,
            url: providers[0].value,
            img: "img/Map/" + (providers[0].configKey == "map_openstreetmap" ? 'OSMap.jpg' : providers[0].configKey == "map_4d" ? "Map4D.jpg" : providers[0].configKey == "map_street" ? "Street.jpg" : "Satellite.jpg")
          }

          tileProviders.value = providers.splice(1).map(i => {
            return {
              name: i.configKey == "map_openstreetmap" ? 'Open Street map' : i.configKey == "map_4d" ? "Map 4D" : i.configKey == "map_street" ? "Map street" : "Satellite",
              shortName: i.configKey == "map_openstreetmap" ? 'OSM' : i.configKey == "map_4d" ? "4D" : i.configKey == "map_street" ? "Street" : "Satellite",
              visible: false,
              url: i.value,
              img: "img/Map/" + (i.configKey == "map_openstreetmap" ? 'OSMap.jpg' : i.configKey == "map_4d" ? "Map4D.jpg" : i.configKey == "map_street" ? "Street.jpg" : "Satellite.jpg")
            }
          })
          const intro = res.data.filter(i => i.configKey == "intro_video")[0]
          introductionVideo.value = intro.value ? intro.value.replace('watch?v=', 'embed/') : 'https://www.youtube.com/embed/yAoLSRbwxL8';
          getCurrentWeather()
        }
      })
    } */

    /*  https://api.weatherapi.com/v1/current.json?key={{}}&q=London */

    const tempC = ref<number>(0)
    const windSpeed = ref<number>(0)
    const humidity = ref<number>(0)
    const iconUrl = ref<string>('')
    const locationName = ref<string>('')
    const condition = ref<string>('')

    const getCurrentWeather = () => {
      const APIKey = "201193e6c030405f99b90347241207"
      const url = `https://api.weatherapi.com/v1/current.json?key=${APIKey}&q=${center.value.toString()}&lang=vi`
      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error(res.statusText)
          return res.json()
        })
        .then((data) => {
          delay(200).then(() => {
            tempC.value = data.current.temp_c
            windSpeed.value = data.current.wind_kph
            humidity.value = data.current.humidity
            iconUrl.value = data.current.condition.icon
            locationName.value = data.location.name
            condition.value = data.current.condition.text
          })
        })
        .catch((err) => {
          console.error(err)
        })

    }

    const openModal = (val: boolean) => {
      pageNum.value = 1
      modalType.value = val
      if (val) {
        modalTitle.value = isEN.value ? "Locations List" : "Danh sách địa chỉ"
      } else {
        modalTitle.value = isEN.value ? "Introduction video" : "Video giới thiệu"
      }
    }

    const openIframe = ref<boolean>(false)

    const iframeURL = ref<string>('')

    const handleOpenLocationUrl = (val) => {
      if (val) {
        /* openIframe.value = true
        iframeURL.value = val */

        window.open(val, '_blank', 'noopener,noreferrer');
        if (document.getElementById("newDropDownId")?.classList.contains("show")) {
          document.getElementById("newDropDownId")?.classList.remove("show")
          if (document.getElementById("newDropDownId")?.classList.contains("newsDropdown")) {
            document.getElementById("newDropDownId")?.classList.remove("newsDropdown")
          }
          if (document.getElementById("newDropDownId")?.classList.contains("newsDropdownMobile")) {
            document.getElementById("newDropDownId")?.classList.remove("newsDropdownMobile")
          }
        }
      }
    }

    const handleCLoseLocationUrl = () => {
      openIframe.value = false
      iframeURL.value = ''
    }

    const disableScrollWheel = () => {
      ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).scrollWheelZoom.disable();
    }

    const enableScrollWheel = () => {
      ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).scrollWheelZoom.enable();
    }

    onMounted(() => {
      window.addEventListener('resize', handleResize);
      if (windowWidth.value < 768) {
        expanded.value = false
      } else {
        expanded.value = true
      }

    });
    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    const mobileToggle = () => {
      expanded.value = !(expanded.value)
      delay(300).then(() => {
        ((companyMap.value as InstanceType<typeof LMap>)?.leafletObject as L.Map).invalidateSize();
      })
    }

    const handleToggleNewsDropDown = () => {
      if (document.getElementById("newDropDownId")?.classList.contains("show")) {
        document.getElementById("newDropDownId")?.classList.remove("show")
        if (document.getElementById("newDropDownId")?.classList.contains("newsDropdown")) {
          document.getElementById("newDropDownId")?.classList.remove("newsDropdown")
        }
        if (document.getElementById("newDropDownId")?.classList.contains("newsDropdownMobile")) {
          document.getElementById("newDropDownId")?.classList.remove("newsDropdownMobile")
        }
      }
      else {
        document.getElementById("newDropDownId")?.classList.add("show")
        if (windowWidth.value <= 425)
          document.getElementById("newDropDownId")?.classList.add("newsDropdownMobile")
        else
          document.getElementById("newDropDownId")?.classList.add("newsDropdown")
      }
    }

    /* const getIntroVideo = () =>{
      store.value.dispatch(Map.getIntroVideo).then(res =>{
        if(res){
          introductionVideo.value = res.intro_video_url
          introductionTitle.value = res.intro_video_title
        }
      })
    } */

    return {
      customIcon,
      swiperOptions,
      companyMap,
      mapOptions,
      pluginOptions,
      leafletSS,
      store,
      zoom,
      tileProviders,
      language,
      isEN,
      selectedTile,
      markerRefs,
      center,
      bounds,
      action,
      drawnMarkers,
      circleColor,
      drawnLines,
      value,
      displayResult,
      unit,
      loading,
      highLighted,
      geoData,
      geoResult,
      searchString,
      searchDistrict,
      modalSearchDistrict,
      filtered,
      districtList,
      highLightDistrict,
      districtBorders,
      filter,
      expanded,
      toolboxOpen,
      layerControlOpen,
      mapModalRef,
      pageNum,
      pageSize,
      totalFilteredLocation,
      filteredLocationList,
      locationList,
      modalTitle,
      modalType,
      introductionVideo,
      introductionTitle,
      /* getIntroVideo, */
      PluginPrep,
      handleChangePage,
      locationFound,
      locationError,
      openPopup,
      locateUser,
      zoomIn,
      zoomOut,
      toggleToolBox,
      toggleLayerControl,
      handleTileChange,
      flyToOnClick,
      handleMoveToCenter,
      handleScreenShot,
      delay,
      handleDrawLine,
      handleDrawPolygon,
      handleFindInfo,
      expandSwiper,
      handleClose,
      handleDrawMarker,
      handleUndo,
      handleDraw,
      handleCalculateDistance,
      handleCalculate,
      handleUnHighlight,
      reverseGeoCoding,
      handleResult,
      windowWidth,
      handleResize,
      findDistrictBorders,
      findAllDistrict,
      findAllLocation,
      //findAllConfig,
      tempC,
      windSpeed,
      humidity,
      iconUrl,
      locationName,
      condition,
      getCurrentWeather,
      openModal,
      openIframe,
      iframeURL,
      handleOpenLocationUrl,
      handleCLoseLocationUrl,
      disableScrollWheel,
      enableScrollWheel,
      baseUrl,
      hideModal,
      preped,
      handleToggleNewsDropDown,
      mobileToggle
    }
  }
})


